<template>

                  <!-- 其他登录方式 -->
                  <div class="other-login-ways">
                    <div class="login-ways">
                      <div class="ways" v-if="federatedUrls.length>0">{{i18n["screen.welcome.label.loginwith"]||'其他方式登录'}}</div>

                      <div class="ways-right" v-for="(federatedUrl, i) in federatedUrls" :key="i">

                      <div class="weixin-wrap" v-if="federatedUrl.type=='openweixin'">
                        <a :href="`${config.casServerPrefix}${federatedUrl.redirectUrl}`" :title="i18n['openweixin']">
                          <i class="su-icon-weixinbian weixin"></i>
                          <i class="su-icon-wechat weixin"></i>
                        </a>
                      </div>
                      <div class="ding-wrap" v-if="federatedUrl.type=='dingtalk'">
                        <a :href="`${config.casServerPrefix}${federatedUrl.redirectUrl}`" :title="i18n['dingtalk']">
                          <i class="su-icon-dingding-inactive ding"></i>
                          <i class="su-icon-dingding ding"></i>
                        </a>
                      </div>
                      <div class="qq-wrap" v-if="federatedUrl.type=='qq'">
                        <a :href="`${config.casServerPrefix}${federatedUrl.redirectUrl}`" :title="i18n['qq']">
                          <i class="su-icon-QQbian qq"></i>
                          <i class="su-icon-tencent qq"></i>
                        </a>
                      </div>
                      <div class="work-wechat-wrap" v-if="federatedUrl.type=='workweixin'">
                        <a :href="`${config.casServerPrefix}${federatedUrl.redirectUrl}`" :title="i18n['workweixin']">
                          <i class="su-icon-qiyeweixin-inactive ww"></i>
                          <i class="su-icon-qiyeweixin ww"></i>
                        </a>
                      </div>
                      <div class="alipay-wrap" v-if="federatedUrl.type=='alipay'">
                        <a :href="`${config.casServerPrefix}${federatedUrl.redirectUrl}`" :title="i18n['alipay']">
                          <i class="su-icon-zhifubao alipay"></i>
                          <i class="su-icon-alipay alipay"></i>
                        </a>
                      </div>

                      </div>

                    </div>
                  </div>

</template>

<script>
export default {
  props: [
    'i18n',
    'config',

    'federatedUrls'
  ],
  data: function data() {
    return {
    }
  },
  created: function created() {
  },
  mounted: function mounted() {
  },
  methods:{
  }
}
</script>
